export const pad = (number: number, length = 2) => {
  const numberLength = number.toString().length;

  if (numberLength < length) {
    const diff = length - numberLength;
    const padding = '0'.repeat(diff);

    return `${padding}${number}`;
  }

  return `${number}`;
}
